const accountStateResetters = new Set();
let accountStateGeneration = 0;

export const registerAccountStateReset = reset => {
    accountStateResetters.add(reset);
    return () => accountStateResetters.delete(reset);
};

export const resetAccountState = () => {
    accountStateGeneration += 1;
    accountStateResetters.forEach(reset => reset());
};

export const getAccountStateGeneration = () => accountStateGeneration;

export const isAccountStateCurrent = generation => (
    generation === accountStateGeneration
);
